import React, { useEffect } from "react";
import Header from "../layout/Header";
import Sidebar from "../layout/Sidebar";
import AllDemographics from "./speechDemographicsGraphs/AllDemographics";
import AsianDemographics from "./speechDemographicsGraphs/AsianDemographics";
import HispanicDemographics from "./speechDemographicsGraphs/HispanicDemographics";
import Bridge from "../constants/Bridge";
import $ from "jquery";

const SpeechDemographics = () => {
  useEffect(() => {
    // audit log
    Bridge.audit_logs.view_speech_study_report_details();
    if ($(window).width() < 600) {
      console.log("window::", window);
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
  }, []);

  return (
    <div>
      <Header />
      <div className="row">
        <Sidebar />
        <div
          className="col-lg-10"
          style={{
            minHeight: "100vh",
            paddingLeft: "32px",
            paddingRight: "30px",
            marginLeft: "auto",
            backgroundColor: "#F5F5F5",
          }}
        >
          <div className="main-section dashboard" style={{ marginTop: 105 }}>
            <div>
              <p
                style={{
                  position: "relative",
                  fontSize: 32,
                  fontFamily: "Open Sans",
                  fontWeight: "bold",
                  color: "#1A4F83",
                  textAlign: "start",
                }}
                className="mb-4 mt-4"
              >
                Speech Study Demographics Report
              </p>
              <div className="p-4 mb-4" style={{ background: "#fff" }}>
                <AllDemographics />
                <AsianDemographics />
                <HispanicDemographics />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeechDemographics;
